export enum SolePanelPostMessageAction {
  EVENT_LISTENER_READY = 'eventListenerReady',
  ORDER_PLACED = 'orderPlaced',
  UPDATE_ORDER_DATA = 'updateOrderData',
}
